import React, { useEffect } from 'react';
import { graphql, Link, PageProps } from 'gatsby';
import UIkit from '../../node_modules/uikit/dist/js/uikit.min.js';
import Layout from '../components/layout';

export default function Template({ data, location }: PageProps<DataType>): JSX.Element {
  const { markdownRemark, zendeskHelpCenterCategory } = data;
  const { frontmatter, html } = markdownRemark;

  useEffect(() => {
    if (!location.hash) {
      return;
    }
    const articleId = location.hash.slice(1);
    zendeskHelpCenterCategory.childrenZendeskHelpCenterSection.forEach((section) => {
      section.childrenZendeskHelpCenterArticle.forEach((article, index) => {
        if (article.articleId.toString() === articleId) {
          UIkit.accordion(`#accordion-${section.id}`).toggle(index, true);
        }
      });
    });
  }, [location.hash]);

  return (
    <Layout seo={{ title: frontmatter.name }}>
      <section className="uk-section uk-section-default">
        <div className="uk-container uk-container-small">
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: html }}
          />
          <hr />
          <h2>ヘルプ</h2>

          <h3>アプリの使い方</h3>
          {zendeskHelpCenterCategory.childrenZendeskHelpCenterSection.map((section) => (
            <div key={section.id}>
              <h4 className="uk-heading-bullet">{section.name}</h4>
              <ul id={`accordion-${section.id}`} data-uk-accordion="collapsible: true">
                {section.childrenZendeskHelpCenterArticle.map((article) => (
                  <li id={article.articleId.toString()} key={article.articleId.toString()}>
                    <a className="uk-accordion-title uk-heading-divider" href="#">{article.title}</a>
                    <div className="uk-accordion-content">
                      <div
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: article.body }}
                      />
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <h3>お問い合わせ</h3>
          <p>
            <Link to="/privacy-policy">プライバシーポリシー</Link>
            をご確認の上、
            <Link to="/contact">こちらから</Link>
            お問い合わせください。
          </p>
        </div>
      </section>
    </Layout>
  );
}

export const pageQuery = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        name
      }
    }
    zendeskHelpCenterCategory(categoryId: {eq: 900001251303}) {
      id
      name
      childrenZendeskHelpCenterSection {
        id
        categoryId
        name
        childrenZendeskHelpCenterArticle {
          articleId
          body
          title
        }
      }
    }
  }
`;

type DataType = {
  markdownRemark: {
    html: string;
    frontmatter: {
      name: string;
    };
  };
  zendeskHelpCenterCategory: {
    id: number;
    name: string;
    childrenZendeskHelpCenterSection: {
      id: number;
      categoryId: number;
      name: string;
      childrenZendeskHelpCenterArticle: {
        articleId: number;
        body: string;
        title: string;
      }[];
    }[];
  };
};
